export enum SearchTabs {
    All = "all",
    Website = "website",
    Keyword = "keyword",
    Reports = "reports",
}
